export const HOME = '/';
export const TEST = '/Test';
export const QUESTION = '/Questionnaire';
export const RESULTS = '/Results';
export const ANALYSIS = '/Analysis';
